// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_gq-0";
export var fulfillmentPanelBody = "_gq-1";